import {
    IDocumentsUploadMonitoringResult,
    IMonitoringResult,
    EMonitoringStatusCode,
    IProgramSetProgram,
    IProgramSetStage,
    EStageStatus,
} from 'store/slices/documents-uploading-slice';

export const stagesDisplaySequenceComparator = (a: IProgramSetStage, b: IProgramSetStage) => (
    a?.displaySequence && b.displaySequence ? a.displaySequence - b.displaySequence : 0
);
export const getStageProgramsCorrespondingMonitoringResult = (
    programSet: IProgramSetProgram[], monitoringResults: IDocumentsUploadMonitoringResult[],
) => {
    const programIdArray = programSet.map(set => set.program?.id);
    const filteredMonitoringResults = monitoringResults
        .filter(monitoringResult => programIdArray.includes(monitoringResult?.program?.id));

    return filteredMonitoringResults.map(monitoringResult => monitoringResult.request);
};

export const getMonitoringStatus = (monitoringResults: IDocumentsUploadMonitoringResult[]) => {
    const lastMonitoringResult = monitoringResults[monitoringResults.length - 1];
    if (lastMonitoringResult) {
        return lastMonitoringResult?.parentRequest?.status?.lookupCode;
    }
    return undefined;
};

// warning and normal are both success
const successResultResolver = (status?: EMonitoringStatusCode) => [
    EMonitoringStatusCode.warning, EMonitoringStatusCode.normal].includes(status as EMonitoringStatusCode);

const generateLogObject = (monitoringResult: IMonitoringResult) => ({
    programId: monitoringResult.programId,
    log: monitoringResult.monitorProgramLog,
});

export const getStageStatus = (stage: IProgramSetStage, stageResults?: IMonitoringResult[]) => {
    const {programSetPrograms: programs} = stage;

    // хотя бы одна программа еще выполняется status = running
    if (stageResults
        && stageResults.some(monitoringResult => monitoringResult.status.lookupCode === EMonitoringStatusCode.running)) {
        return {status: EStageStatus.pending};
    }
    // часть программ завершилась успешно
    if (stageResults && programs?.length > stageResults?.length
        && stageResults.some(monitoringResult => successResultResolver(monitoringResult?.status?.lookupCode))) {
        return {status: EStageStatus.pending};
    }

    // хотя бы одна программа завершилась с ошибкой
    if (stageResults && programs?.length === stageResults?.length
        && stageResults?.find(monitoringResult => monitoringResult.status.lookupCode === EMonitoringStatusCode.error)) {
        return {
            status: EStageStatus.reject,
            logs: stageResults.map(monitoringResult => generateLogObject(monitoringResult)),
        };
    }

    // все программы завершились успешно
    if (programs?.length === stageResults?.length
        && stageResults?.every(monitoringResult => successResultResolver(monitoringResult?.status?.lookupCode))) {
        return {
            status: EStageStatus.success,
            logs: stageResults.map(monitoringResult => generateLogObject(monitoringResult)),
        };
    }

    return {status: EStageStatus.initial};
};
